import type { EmployeeAssistance } from 'src/api/generated';
import type { I18nContextValue } from 'src/modules/shared/types/i18n/i18n.type';
import { getEmployeeBlockerPresentation } from './employee-blocker-presentation.util';
import { getCapabilityDisplayName } from './employee-tool-presentation.util';

/**
 * Builds tenant-facing copy for blocking and advisory assistance records.
 *
 * @param assistance - Assistance record returned by the Automations API.
 * @param translate - Tenant-localized translation function.
 * @returns Localized category, reason, and sanitized context labels.
 */
export const getEmployeeAssistancePresentation = (
  assistance: EmployeeAssistance,
  translate: I18nContextValue['t']
) => {
  if ('blocker' in assistance) {
    return getEmployeeBlockerPresentation(assistance.blocker, translate);
  }

  return {
    categoryLabel: translate(
      'automations.aiAgents.assistance.category.messageFidelityReview'
    ),
    reason: translate(
      'automations.aiAgents.assistance.reason.messageFidelityReview'
    ),
    context: translate(
      'automations.aiAgents.assistance.advisory.messageFidelityReviewContext',
      {
        operation: getCapabilityDisplayName(
          assistance.advisory.operationKind,
          translate
        ),
        issueCount: assistance.advisory.issueCount,
      }
    ),
  };
};
